export default __webpack_public_path__ + "static/dynamic-compound-intransitive-d2a39ac9716e791dbaf760132db89795.svg";